export const STITCH_CONSTANTS = {
  // Fits tallest stitch (treble ±15) into ±12 of the ±13 icon viewbox
  ICON_SCALE: 12 / 15,

  // Icon sizes for menu and preview
  ICON: {
    SIZE: 26,
    VIEWBOX: {
      MIN: -13,
      MAX: 13,
      WIDTH: 26,
      HEIGHT: 26
    }
  },

  // Line stroke widths
  STROKE_WIDTH: {
    ICON: 2,
    CANVAS: 2
  },

  // Legend dimensions for export
  LEGEND: {
    PADDING: 20,
    STITCH_SIZE: 40,
    STITCH_TEXT_GAP: 10,
    ITEMS_PER_ROW: 3,
    ROW_GAP: 30,
    TEXT_COLOR: '#382f2d',
    STITCH_COLOR: '#382f2d',
    MAX_TEXT_WIDTH: 120,
    LINE_HEIGHT: 18
  }
} as const;
